import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

document.addEventListener("DOMContentLoaded", function () {
	initDatePicker();
});

window.initDatePicker = () => {
	flatpickr(".date-picker", {
		enableTime: false,
		dateFormat: "d/m/Y"
	});
}
